import { render, staticRenderFns } from "./SortButtons.vue?vue&type=template&id=23774aee&scoped=true&"
import script from "./SortButtons.vue?vue&type=script&lang=js&"
export * from "./SortButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23774aee",
  null
  
)

export default component.exports